import React, {useState, useEffect} from 'react';
import {Grid , Chip, ListItem, ListItemIcon, ListItemText, Divider} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {Today, LocationOn, Description, Filter1 } from '@material-ui/icons';
import {functions} from 'constants/index';

function DatosCiudadano(props) {   
    const classes = useStyles()
    const [datosCiudadanoTable, setdatosCiudadanoTable] = useState({
        numSolicitud:0,
        puestoEmpadronamiento:'',
        fechaSolicitud:'',
        nroSolicitudRenap: '',
    });
   
    useEffect(() => {
        if(JSON.stringify(props.datosCiudadanoTable)!=='{}'){
            var puestoEmpadronamiento = ''
            if(props.datosCiudadanoTable.puestoEmpadronamiento === null) puestoEmpadronamiento = ''
            else puestoEmpadronamiento = props.datosCiudadanoTable.puestoEmpadronamiento.nombrePuesto;

            setdatosCiudadanoTable({ 
                numSolicitud: props.datosCiudadanoTable.idSolicitud,
                puestoEmpadronamiento: puestoEmpadronamiento,
                // fechaSolicitud: props.datosCiudadanoTable.datosSolicitudEmpadronamiento.fechaSolicitud,
                fechaSolicitud: functions.splitDate(props.datosCiudadanoTable.datosSolicitudEmpadronamiento.fechaParseada),
                nroSolicitudRenap: props.datosCiudadanoTable.datosSolicitudEmpadronamiento.nroSolicitudRenap
            })
        }
    },[props.datosCiudadanoTable])
    return (
        <Grid container >
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>DATOS DE LA SOLICITUD ENVIADAS POR EL RENAP</strong> <Divider /></div>
            </Grid >
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="No. de Solicitud TSE: " />
                        <ListItemIcon className={classes.colorIcon}><Description/></ListItemIcon>
                    </ListItem>
                </Grid>
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.numSolicitud} />                                
                </Grid>
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="Fecha de Solicitud: " />
                        <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                    </ListItem>
                </Grid>
                <Grid item xs={3}>
                    {/* <Chip className={classes.colorChip} label={datosCiudadanoTable.fechaSolicitud} /> */}
                    <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.fechaSolicitud} />                                
                </Grid> 
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="No. Solicitud RENAP: " />
                        <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                    </ListItem>
                </Grid>
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.nroSolicitudRenap} />                                
                </Grid>                
        </Grid> 
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadano);